import { ArticleParagraph1, Faq16, InformationTooltip, Wait16 } from '@cian/ui-kit';
import * as React from 'react';

import { EInformerLevel } from '../../../types/rosreestr';
import * as styles from './RosreestrItemTooltip.css';

interface ITooltipProps {
  title: string;
  description: string[];
  informerLevel?: EInformerLevel | null;
}

export function RosreestrItemTooltip({ title, description, informerLevel }: ITooltipProps) {
  const [open, setOpen] = React.useState(false);

  const IconComponent = React.useMemo(
    () => (informerLevel === EInformerLevel.Warning ? Wait16 : Faq16),
    [informerLevel],
  );

  const iconColor = React.useMemo(
    () => (informerLevel === EInformerLevel.Warning ? 'warning_100' : 'primary_100'),
    [informerLevel],
  );

  const openModal = React.useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = React.useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <InformationTooltip
      open={open}
      header={title}
      content={
        <>
          {description.map((text, index) => (
            <div className={styles['item']} key={index}>
              <ArticleParagraph1>{text}</ArticleParagraph1>
            </div>
          ))}
        </>
      }
      onClose={closeModal}
    >
      <button type="button" className={styles['button']} onClick={openModal}>
        <IconComponent color={iconColor} />
      </button>
    </InformationTooltip>
  );
}
